import { render, staticRenderFns } from "./ModalSaveTestResult.vue?vue&type=template&id=fa29a396&scoped=true&lang=pug&"
import script from "./ModalSaveTestResult.vue?vue&type=script&lang=ts&"
export * from "./ModalSaveTestResult.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSaveTestResult.vue?vue&type=style&index=0&id=fa29a396&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa29a396",
  null
  
)

export default component.exports